import React from 'react'
import YesNoButtons from '../formGroup/YesNoButtons'
import { IIdentityQuestion } from '../../interfaces/Identity'

const IdentityQuestion = ({
  onRadioChange,
  existing_identity,
  register,
  error,
}: IIdentityQuestion) => {
  return (
    <div className="dFlex alignItemsStart flexWrap flexColumn flexMdRow mb2">
      <strong className="fontWeightBold fontSizeSm fontStyleIt mb15 mb0lg mr3 mr5md">
        Les informations présentées ci-dessous correspondent-elles à vos données
        d’identité ?
      </strong>
      <div className="dFlex ml3 flexColumn">
        <YesNoButtons
          value={existing_identity}
          register={register({ required: true })}
          error={error.existing_identity}
          id="existing_identity"
          name="existing_identity"
          yesValue="1"
          noValue="0"
          required
          labelClassName="mb1"
          onChange={onRadioChange}
        />
      </div>
    </div>
  )
}

export default IdentityQuestion
